__turbopack_context__.v({
  "profileCard": "IssueLeaderProfile-module__Cg0uVG__profileCard",
});
